import { SkillEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { ListeningTimeLimit } from './ListeningTimeLimit';
import { PracticeTestTimeLimit } from './PracticeTestTimeLimit';
import { ReadingTimeLimit } from './ReadingTimeLimit';

export const TimeLimit = observer(() => {
  const { isPreviewMode, skill, testType } = useTestSubmissionStore();

  if (testType === TestTypeEnum.PRACTICE_TEST || isPreviewMode) {
    return <PracticeTestTimeLimit />;
  }

  switch (skill) {
    case SkillEnum.LISTENING: {
      return <ListeningTimeLimit />;
    }
    case SkillEnum.READING: {
      return <ReadingTimeLimit />;
    }
  }
  return null;
});
